import {useState,useEffect} from "react";
import '../styles/nosotros.css';
import fachada from '../assets/fachadajm.jpg'
import juguetebarro from '../assets/juguetebarro.jpg'
import juguetecocina from '../assets/juguetecocina.jpg'
import juguetemuerto from '../assets/juguetemuerto.jpg'
import parroquia from '../assets/amozoc/amozocparroquia.jpg'
import zocalo from '../assets/amozoc/amozoczocalo.jpg'
import exconvento from '../assets/amozoc/amozocconvento.jpg'
import jugueteria from '../assets/amozoc/amozocjugueteriamago.jpg'

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});


function Nosotros(){

    const posicion = [19.0450145, -98.04282]; // Coordenadas jugueteria
    const posParroquia = [19.0449831,-98.0451076]; // Coordenadas parroquia
    const poscentro = [19.0446372,-98.0441388] // Coordenadas amozoc centro
    const posexconvento = [19.044408,-98.043487] // Coordenadas exconvento

    const imagenes = [juguetebarro, juguetecocina,juguetemuerto]; 
    const [indiceActual, setIndiceActual] = useState(0);

    useEffect(() => {
        const intervalo = setInterval(() => {
        setIndiceActual((prevIndex) => (prevIndex + 1) % imagenes.length);
        }, 4000);

        return () => clearInterval(intervalo); 
    }, [imagenes.length]);

    return(
        <div>
            <div className="mensaje-nosotros">
                <h2>
                En Juguetería Mago, desde nuestro hogar en Amozoc, Puebla, te ofrecemos artesanías 
                y artículos religiosos hechos con todo el cariño y dedicación de nuestra familia, 
                que con más de 40 años de experiencia pone el corazón en cada detalle de nuestras creaciones.
                </h2>
            </div>
            <div className="fachada">
                <img src={fachada} alt="Jugueteria Mago" />
            </div>
            <div className="pregunta">
                <h3>¿ Por qué "jugueteria" ?</h3>
                <p className="texto-pregunta">El nombre de jugueteria se remonta a los inicios donde los principales
                    artículos producidos eran juguetes varios como silbatos, sonajas y algunas figuras
                    como animales.
                </p>
                <p className="texto-pregunta">
                    El material principal era el "barro", que es una mezcla de de tierra y sedimentos que 
                    tu puedes moldear. Los colores y formas tan llamativos lograron dar popularidad a estos 
                    negocios locales que convservaron el nombre que en un origen tomaron.
                </p>
                <div className="imagen-pregunta">
                    <img src={imagenes[indiceActual]} alt="imagen" />
                </div>
            </div>
            <div className="ubicacion">
                <h3>¿ En dónde nos encuentras ?</h3>
                <p className="texto-ubicacion">
                    Jugueteria Mago se ubica en el centro de Amozoc, a un costado de el Ex Convento Franciscano,
                    más precisamente en la calle 2 Oriente tambien conocida como calle de las artesanias. <br />
                    Nuestro horario es de 9:00 a.m a 7:00 p.m todos los dias del año, excepto dias festivos.
                    
                </p>
                <p>
                Ubícanos en el mapa de abajo o{" "}
                <a className="enlace-ubicacion"
                    href="https://www.google.com/maps/place/Jugueteria+Mago/@19.0449485,-98.0426604,17z/data=!4m14!1m7!3m6!1s0x85cfec9c5c26abc5:0xd9229c6f1a94ef12!2sJugueteria+Mago!8m2!3d19.0449485!4d-98.0426604!16s%2Fg%2F11hbqkpb17!3m5!1s0x85cfec9c5c26abc5:0xd9229c6f1a94ef12!8m2!3d19.0449485!4d-98.0426604!16s%2Fg%2F11hbqkpb17?entry=ttu&g_ep=EgoyMDI1MDkyNC4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    da clic aquí para visitarnos
                </a>
                .
                </p>
                <div className="mapa">
                    
                    <MapContainer center={posicion} zoom={25} style={{ height: '300px', width: '100%' }}>
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={posicion} icon={redIcon}>
                        <Popup maxWidth={500}> {/* Aumentamos el ancho del popup */}
                            <div style={{ textAlign: 'center' }}>
                            <strong>Juguetería Mago</strong>
                            <br />
                            <img
                                src={jugueteria}
                                alt="Juguetería Mago"
                                style={{
                                width: '650px',         // Imagen más grande
                                maxWidth: '250px',       // Responsiva si el contenedor es más chico
                                height: 'auto',
                                borderRadius: '8px',
                                marginTop: '5px'
                                }}
                            />
                            </div>
                        </Popup>
                        </Marker>
                         <Marker position={posParroquia}>
                            <Popup maxWidth={300}>
                            <div style={{ textAlign: 'center' }}>
                                <strong>Parroquia Santa María de la asunción</strong>
                                <br />
                                <img
                                src={parroquia}
                                alt="Parroquia"
                                style={{ width: '100%', borderRadius: '8px', marginTop: '5px' }}
                                />
                            </div>
                            </Popup>
                        </Marker>
                        <Marker position={poscentro}>
                            <Popup maxWidth={300}>
                            <div style={{ textAlign: 'center' }}>
                                <strong>Zócalo Amozoc</strong>
                                <br />
                                <img
                                src={zocalo}
                                alt="zócalo"
                                style={{ width: '100%', borderRadius: '8px', marginTop: '5px' }}
                                />
                            </div>
                            </Popup>
                        </Marker>
                        <Marker position={posexconvento}>
                            <Popup maxWidth={300}>
                            <div style={{ textAlign: 'center' }}>
                                <strong>Ex Convento Franciscano Amozoc</strong>
                                <br />
                                <img
                                src={exconvento}
                                alt="exconvento"
                                style={{ width: '100%', borderRadius: '8px', marginTop: '5px' }}
                                />
                            </div>
                            </Popup>
                        </Marker>
                    </MapContainer>
                </div>

                <div className="texto-final">
                    <h3> ! Te esperamos pronto !</h3>
                </div>
                
            </div>
        </div>
        
    )

}

export default Nosotros;